/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Ctl_One_LinerInputs */

const en_exp_ctl_one_liner = /** @type {(inputs: Exp_Ctl_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness level built up over the past ~6 weeks of training.`)
};

const de_exp_ctl_one_liner = /** @type {(inputs: Exp_Ctl_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Fitnesslevel — aufgebaut über die letzten ~6 Wochen Training.`)
};

/**
* | output |
* | --- |
* | "Your fitness level built up over the past ~6 weeks of training." |
*
* @param {Exp_Ctl_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_ctl_one_liner = /** @type {((inputs?: Exp_Ctl_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Ctl_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_ctl_one_liner(inputs)
	return de_exp_ctl_one_liner(inputs)
});